import { SHOW_SPINNER, HIDE_SPINNER } from 'actionTypes'

export const showSpinner = (msg, isReactive = false, reactiveCallback) => ({ type: SHOW_SPINNER, msg, isReactive, reactiveCallback })

export const hideSpinner = (msg) => ({ type: HIDE_SPINNER, msg })
